/* eslint-disable */

import OpeningTitleVideo from './Videos/opening-title.webm'
import ClosingTitleVideo from './Videos/closing-title.webm'
import UnrealWorldVideo from './Videos/unreal-world.webm'
import ChesmacVideo from './Videos/chesmac.webm'
import UunoTurhapuroVideo from './Videos/uuno-turhapuro.webm'
import MaxPayneVideo from './Videos/max-payne.webm'
import AngryBirdsVideo from './Videos/angrybirds.webm'
import SanxionVideo from './Videos/sanxion.webm'
import SlicksNSlideVideo from './Videos/slicks-n-slide.webm'
import SnakeVideo from './Videos/snake.webm'
import ClashOfClansVideo from './Videos/clash-of-clans.webm'

const SlidesSv = [
  {
    index: 0,
    mainLayoutType: 'full',
    content: {
      components: [
        {
          componentType: 'video',
          src: OpeningTitleVideo,
          bgColor: '#0000FF'
        }
      ]
    }
  },
  {
    index: 1,
    mainLayoutType: 'split',
    content: {
      left: {
        main: {
          components: [
            {
              componentType: 'heading',
              headingLevel: '1',
              text: 'Chesmac (1979)'
            },
            {
              componentType: 'heading',              
              headingLevel: '2',
              text: 'Historia:'
            },
            {
              componentType: 'text',
              text: 'Schackspelet Chescmac, som Raimo Suonio skapade i ett projekt på sin fritid, är Finlands allra första kommersiella dataspel. Under en kort arbetslöshetsperiod 1979 utvecklade Suonio Chesmac på skoj för den finländska byggsatsdatorn Telmac, vars datakraft i slutet av 1970-talet inte var så mycket att skryta med. Trots att Suonio inte var professionell spelutvecklare ville han som den nyfikna designersjäl han var, undersöka om Telmac TMC-1800 skulle klara av att utföra de avancerade funktionerna i ett schackspel. Det kunde den. En klassiker var född.'
            },
            {
              componentType: 'heading',              
              headingLevel: '2',
              text: 'Visste du att:'
            },
            {
              componentType: 'text',
              text: 'Även Chesmac var en utopi på sin tid. En maskin som kunde tänka strategiskt med sin konstgjorda intelligens. C-kassetten med Chesmac blev också en kommersiell framgång, som såldes via Raimo Suonios nya arbetsplats Topdata i svindlande 104 exemplar. I 1970- och 1980-talets Finland var det en aktningsvärd siffra. Chesmac går fortfarande att ladda ner från nätet. Själv har spelets designer Suonio, ironiskt nog, aldrig varit intresserad av schack.'
            }
          ]
        },
        footnotes: {
          components: [
            {
              componentType: 'text',
              text: 'Huvuddesigner: Raimo Suonio',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Utgivare: Raimo Suonio / Topdata',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Plattform: Telmac TMC-1800',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Format: C-kassett',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Genre: Problemspel / ensamspel',
              style: 'small'
            },
          ]
        },
      },
      right: {
        components: [
          {
            componentType: 'video',
            src: ChesmacVideo
          },
        ]
      }
    }
  },
  {
    index: 2,
    mainLayoutType: 'split',
    content: {
      left: {
        main: {
          components: [
            {
              componentType: 'heading',
              headingLevel: '1',
              text: 'Sanxion (1986)'
            },
            {
              componentType: 'heading',              
              headingLevel: '2',
              text: 'Historia:'
            },
            {
              componentType: 'text',
              text: 'Sanxion är designat av pionjären inom finländsk speldesign Stavros Fasoulas (1968-) och är ett av de mest betydande skjutspelen i hela världen från 1980-talet. Det speciella med Sanxion var att bildskärmen är delad så att spelaren kunde se sitt rymdskepp samtidigt både från sidan och uppifrån. Sanxion var i första hand avsett som ett utmanande vuxenspel som krävde både fingerfärdighet och en taktisk blick. Ljudvärlden i Sanxion var helt revolutionerande.'
            },
            {
              componentType: 'heading',              
              headingLevel: '2',
              text: 'Visste du att:'
            },
            {
              componentType: 'text',
              text: 'När Sanxion kom ut 1986 kallade den legendariske speljournalisten Niko Nirvi spelets designer Stavros Fasoulas för ”datorspelens Paavo Nurmi” efter denne Finlands störste långdistanslöpare. Den elektroniska signaturmelodin till Sanxion skapades med hjälp av SID-teknik av den kände brittiske spelkompositören Ron Hubbard (1956-) och är fortfarande en av spelvärldens absoluta klassiker. Originalmusiken härstammar från sergey prokofievs dance of the knights från Romeo och Julia.'
            }
          ]
        },
        footnotes: {
          components: [
            {
              componentType: 'text',
              text: 'Huvuddesigner: Stavros Fasoulas',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Utgivare: Thamalus',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Plattform: Commodore 64',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Format: C-kassett / diskett',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Genre: Skjutarspel / ensamspel',
              style: 'small'
            },
          ]
        },
      },
      right: {
        components: [
          {
            componentType: 'video',
            src: SanxionVideo
          },
        ]
      }
    }
  },
  {
    index: 3,
    mainLayoutType: 'split',
    content: {
      left: {
        main: {
          components: [
            {
              componentType: 'heading',
              headingLevel: '1',
              text: 'Uuno Turhapuro flyttar till landet (1986)'
            },
            {
              componentType: 'heading',              
              headingLevel: '2',
              text: 'Historia:'
            },
            {
              componentType: 'text',
              text: 'Videospelsdesignern Pasi Hytönen programmerade Uuno Turhapuro flyttar till landet på ett par månader redan under gymnasietiden. Det är det första digitala licensspel som gjorts av en finländsk film. Förväntningarna var höga, karaktären Uuno Turhapuro i Vesa-Matti Loiris gestalt var ju megapopulär i 1980-talets Finland. Det handlar om ett actionspel på relativt hög grafisk nivå, där man istället för att skjuta plöjer åkrar, springer i skogen och sysslar med barfota vattenskidåkning. Uuno är programmerad med sprite- och teckengrafik och styrs av spelaren på uppåt/neråt-axeln. Programmeringsspråket var Commodores eget. Källkoden hade Hytönen med sitt globala sinnelag kopierat från utländska tidningar.'
            },
            {
              componentType: 'heading',              
              headingLevel: '2',
              text: 'Visste du att:'
            },
            {
              componentType: 'text',
              text: 'Uuno Turhapuro flyttar till landet lever kvar i minnet som ett nästan frustrerande svårt spel. Designern Hytönen var orolig att den lätta filmen skulle bli ett alltför lätt spel. Det blev det inte. Enligt en kritiker spelas Uuno Turhapuro flyttar till landet bara av ”sadister”. Sammanlagt har spelet sålts i dryga 2 000 exemplar i Finland.'
            }
          ]
        },
        footnotes: {
          components: [
            {
              componentType: 'text',
              text: 'Huvuddesigner: Pasi Hytönen',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Utgivare: Amersoft',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Plattform: Commodore 64',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Format: C-kassett / diskett',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Genre: Actionspel / ensamspel',
              style: 'small'
            },
          ]
        },
      },
      right: {
        components: [
          {
            componentType: 'video',
            src: UunoTurhapuroVideo
          },
        ]
      }
    }
  },
  {
    index: 4,
    mainLayoutType: 'split',
    content: {
      left: {
        main: {
          components: [
            {
              componentType: 'heading',
              headingLevel: '1',
              text: 'UnReal World (1982)'
            },
            {
              componentType: 'heading',              
              headingLevel: '2',
              text: 'Historia:'
            },
            {
              componentType: 'text',
              text: 'UnReal World är ett överlevnadsspel som utspelar sig i en fantasivärld som liknar ett förhistoriskt Finland, och som kan hålla på hur länge som helst. Men så handlar det också om den ene spelutvecklaren Sami Maaranens livsverk, som har pågått utan avbrott ända sedan 1982. Spelet uppdateras fortfarande med regelbundna intervaller. UnReal World hämtar sin näring i finska folksägner från järnåldern (500 f.Kr. – 1300 e.Kr). Naturen är starkt närvarande. För att klara sig i spelet måste man vara stark och påhittig. Realism är hjärtat i UnReal World. Till exempel får spelfiguren hudskador av förfrysning.'
            },
            {
              componentType: 'heading',              
              headingLevel: '2',
              text: 'Visste du att:'
            },
            {
              componentType: 'text',
              text: 'Bland figurerna i UnReal World finns bland annat en fiskare samt en eremit som lever omgiven av snöstormar och vilda djur. NärUnReal World uppdateras tar man hänsyn även till den verkliga världen. Till exempel tar spelet upp följderna av klimatförändringen. Under senare år har UnReal World även fått stor internationell uppmärksamhet.'
            }
          ]
        },
        footnotes: {
          components: [
            {
              componentType: 'text',
              text: 'Huvuddesigner: Sami Maaranen, Erkka Lehmus',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Utgivare: Enormous Elk',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Plattform: Windows / Mac OS X / Linux',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Format: C-kassett / diskett / numera nedladdningsbar från nätet',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Genre: Ändlöst överlevnadsäventyr / ensamspel',
              style: 'small'
            },
          ]
        },
      },
      right: {
        components: [
          {
            componentType: 'video',
            src: UnrealWorldVideo
          },
        ]
      }
    }
  },
  {
    index: 5,
    mainLayoutType: 'split',
    content: {
      left: {
        main: {
          components: [
            {
              componentType: 'heading',
              headingLevel: '1',
              text: 'Slicks ‘n Slide (1993)'
            },
            {
              componentType: 'heading',              
              headingLevel: '2',
              text: 'Historia:'
            },
            {
              componentType: 'text',
              text: 'Timo och Juha Kauppinens racingspel Slicks ’n’ Slide hör till klassikerna i sin genre. Spelets grundidé är enkel: köra bil fortare än de andra runt en kort bana. Grafiskt var Slicks ’n’ Slide inte lysande, men det kunde på ett ovanligt lyckat sätt förmedla den magiska känsla som biltävlingar ofta associeras med. Spelet hade en smart artificiell intelligens, men den mest beroendeframkallande egenskapen hos Slicks ’n’ Slide var att man kunde spela fyra personer tillsammans. Och ja, de använde oftast samma tangentbord när de spelade. Och då blev det roligt.'
            },
            {
              componentType: 'heading',              
              headingLevel: '2',
              text: 'Visste du att:'
            },
            {
              componentType: 'text',
              text: 'Slicks ’n’ Slide hade ett ovanligt mångsidigt fordonsutbud. Förutom bilar kunde man välja till exempel motorcykel, pansarvagn eller ufo. I senare versioner tillkom extrautrustning såsom olika slags vapen. Slicks ’n’ Slide var en representant för deltagande design – deltagarna kunde göra sina egna banor med hjälp av en fälteditor. Spelet går fortfarande att hämta på nätet.'
            }
          ]
        },
        footnotes: {
          components: [
            {
              componentType: 'text',
              text: 'Huvuddesigner: Timo Kauppinen / Juha Kauppinen',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Utgivare: Shareware / gratis dataprogram',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Plattform: MS-DOS / Microsoft Windows',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Format: I början diskett / numera nedladdning från nätet',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Genre: Racingspel /ensamspel / flerspelarspel',
              style: 'small'
            },
          ]
        },
      },
      right: {
        components: [
          {
            componentType: 'video',
            src: SlicksNSlideVideo
          },
        ]
      }
    }
  },
  {
    index: 6,
    mainLayoutType: 'split',
    content: {
      left: {
        main: {
          components: [
            {
              componentType: 'heading',
              headingLevel: '1',
              text: 'Snake (1997)'
            },
            {
              componentType: 'heading',              
              headingLevel: '2',
              text: 'Historia:'
            },
            {
              componentType: 'text',
              text: 'Nokias eget Maskspel som baserades på utländska klassikerspel från1970-talet är nog mer berömt ute i världen än någon av företagets mobiltelefoner. Det säger allt om hur populärt detta oerhört enkla men vanebildande spel var i slutet av 1990-talet i hela världen. Utöver det ursprungliga spelet publicerade Nokia flera mer avancerade versioner av Snake, men ingen lyckades konstigt nog uppnå den hypnotiska dragkraften hos det ursprungliga spelet.'
            },
            {
              componentType: 'heading',              
              headingLevel: '2',
              text: 'Visste du att:'
            },
            {
              componentType: 'text',
              text: 'Som så många ikoniska verk i designens historia kom även Nokias ursprungliga Maskspel till nästan av misstag. Taneli Armanto var anställd som spelutvecklare och arbetade 1997 i utvecklingsteamet för Nokias telefon 6110, och alla trodde att han var en kompetent spelutvecklare. Man hade dock förväxlat Taneli Armanto med en släkting som hette nästan likadant och hade mer erfarenhet av spelutveckling. Trots förväxlingen fortsatte Taneli Armanto sin famlande utvecklingsprocess, som ledde till skapandet av ett av de mest ikoniska spelen i populärkulturen. '
            }
          ]
        },
        footnotes: {
          components: [
            {
              componentType: 'text',
              text: 'Huvuddesigner: Taneli Armanto',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Utgivare: Nokia',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Plattform: Nokia 6110 och andra Nokia-mobiler',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Format: Mobilspel',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Genre: Skicklighetsspel',
              style: 'small'
            },
          ]
        },
      },
      right: {
        components: [
          {
            componentType: 'video',
            src: SnakeVideo
          },
        ]
      }
    }
  },
  {
    index: 7,
    mainLayoutType: 'split',
    content: {
      left: {
        main: {
          components: [
            {
              componentType: 'heading',
              headingLevel: '1',
              text: 'Max Payne (2001)'
            },
            {
              componentType: 'heading',              
              headingLevel: '2',
              text: 'Historia:'
            },
            {
              componentType: 'text',
              text: 'Max Payne skapades av Finlands mest kända spelmanusförfattare Sami Järvi (1970-) och revolutionerade spelbranschen med sin tidsfördröjande bullet time-teknik. Varken i fråga om artificiell intelligens eller grafik var Max Payne enastående, men berättandet var av högsta klass. Det var inget traditionellt skjutspel utan en sammanhängande berättelse, som hade en intrig, sarkastiska dialoger och till och med moral. Även de serieteckningsaktiga mellanspelen i film noir-stil var revolutionerande. Max Payne var det första finländska högbudgetspelet, och det gav även utvecklaren Remedy världsberömmelse.'
            },
            {
              componentType: 'heading',              
              headingLevel: '2',
              text: 'Visste du att:'
            },
            {
              componentType: 'text',
              text: 'Max Payne fick två fortsättningsdelar och blev även film i Hollywood. I seriens första del spelades karaktärerna av Remedys egna anställda och manusförfattaren Sami Järvi själv gav ansiktet åt spelets huvudperson. Efter Max Payne har Remedy publicerat även Alan Wake (2010) och Quantum Break (2016), som båda är internationella kritiker- och försäljningsframgångar.'
            }
          ]
        },
        footnotes: {
          components: [
            {
              componentType: 'text',
              text: 'Huvuddesigner: Sami Järvi',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Utgivare: Remedy / Rockstar Games / Feral Interactive',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Plattform: Microsoft Windows / PlayStation 2 / Xbox / Game Boy Advance / Macintosh',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Format: CD / DVD',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Genre: Tredjepersonsskjutspel /ensamspel',
              style: 'small'
            },
          ]
        },
      },
      right: {
        components: [
          {
            componentType: 'video',
            src: MaxPayneVideo
          },
        ]
      }
    }
  },
  {
    index: 8,
    mainLayoutType: 'split',
    content: {
      left: {
        main: {
          components: [
            {
              componentType: 'heading',
              headingLevel: '1',
              text: 'Angry Birds (2009)'
            },
            {
              componentType: 'heading',              
              headingLevel: '2',
              text: 'Historia:'
            },
            {
              componentType: 'text',
              text: 'Angry Birds, som berättar om trätor mellan fåglar och grisar, är en av de mest framgångsrika spelserierna i populärhistorien. Hur hela världen kunde bli tokig i detta enkla problemspel är ett mysterium, men ett positivt sådant. En teori är att Angry Birds kom vid en tidpunkt när konsumenternas spelföväntningar höll på att gå över från dator- och konsolspel till mobila enheter. Angry Birds gjorde spelutvecklaren Rovio till en internationell superstjärna. De arga fåglarna lyfte slutligen den finländska spelindustrin till en topposition i världen.'
            },
            {
              componentType: 'heading',              
              headingLevel: '2',
              text: 'Visste du att:'
            },
            {
              componentType: 'text',
              text: 'Angry Birds var det 52:a spelet som Rovio gjorde. Om det inte hade gått vägen, hade hela företagets framtid varit hotad. Av central betydelse för genombrottet var programmeringsspråket Lua, som gjorde spelet smidigare. Det har gjorts oräkneliga delar av Angry Birds-serien och även en animerad helaftonsfilm. De arga fåglarnas humor slår fortfarande.'
            }
          ]
        },
        footnotes: {
          components: [
            {
              componentType: 'text',
              text: 'Huvuddesigner: Jaakko Iisalo / Rovio',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Utgivare: Clickgamer.com / Chillingo Ltd.',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Plattform: Smartphones / surfplattor och spelkonsoler',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Format: Nätbutiker på internet / blu-ray disc',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Genre: Problemspel / ensamspel',
              style: 'small'
            },
          ]
        },
      },
      right: {
        components: [
          {
            componentType: 'video',
            src: AngryBirdsVideo
          },
        ]
      }
    }
  },
  {
    index: 9,
    mainLayoutType: 'split',
    content: {
      left: {
        main: {
          components: [
            {
              componentType: 'heading',
              headingLevel: '1',
              text: 'Clash of Clans (2012)'
            },
            {
              componentType: 'heading',              
              headingLevel: '2',
              text: 'Historia:'
            },
            {
              componentType: 'text',
              text: 'Clash of Clans kommer att gå till världshistorien som en av de mest framgångsrika designprodukterna genom tiderna. Superpopulariteten grundas på två saker: Spelutvecklaren Supercell lyckades locka till sig även personer som inte varit intresserade av mobilspel tidigare. Och att en stor del av dem som spelar Clash of Clans har varit beredda att köpa även tilläggsinnehåll som kostar pengar. Även om dessa mikrobelopp ofta är små för den enskilda spelaren utgör de en enorm inkomstpost tillsammans. Precis som Rovio lyckades Supercell med det som många designers misslyckas med: att kommersialisera sin produkt.'
            },
            {
              componentType: 'heading',              
              headingLevel: '2',
              text: 'Visste du att:'
            },
            {
              componentType: 'text',
              text: 'Grundtanken med Clash of Clans är att bygga en egen by, ansluta sig till en klan och sedan bredda sitt ägande genom att anfalla andra spelares byar och erövra dem. Supercell under Ilkka Paananens ledning är ett typexempel på hur formgivare och företag om de vill kan bryta sig ut ur sin egen genre och delta aktivt i det samhälleliga samtalet.'
            }
          ]
        },
        footnotes: {
          components: [
            {
              componentType: 'text',
              text: 'Huvuddesigner: Supercell',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Utgivare: Supercell',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Plattform: iOS / Android',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Format: Mobilspel',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Genre: Strategispel / flerspelarspel',
              style: 'small'
            },
          ]
        },
      },
      right: {
        components: [
          {
            componentType: 'video',
            src: ClashOfClansVideo
          },
        ]
      }
    }
  },
  {
    index: 10,
    mainLayoutType: 'full',
    content: {
      components: [
        {
          componentType: 'video',
          src: ClosingTitleVideo,
          bgColor: '#0000FF'
        }
      ]
    }
  }
]

export default SlidesSv



// WEBPACK FOOTER //
// ./src/SlidesSv.js